module.exports = __webpack_public_path__ + "static/img/cab-builder.21b0e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cab-builder.jpg
// module id = D8xC
// module chunks = 1